import $ from 'jquery';

class Forms {

    constructor() {
        this.input = '.form__input:not(.novalid), .form__textarea';
        this.inputNumber = '.form__number';
        this.form = '.form';
        this.formsAjax = '.form__ajax';

        this.setEmpty();
        this.bindFocus();
        this.bindInputKeyUp();
        this.bindValidate();
        this.bindSubmit();
        this.bindAjaxSubmit();
        this.bindNumber();

    }

    setEmpty() {
        $(this.input).each((index, element) => {
            if ($(element).val() === '' || $(element).val() === null) {
                $(element).addClass('empty');
            }
        });
    }

    bindFocus() {
        $(this.input).on('focus', (event) => {
            $(event.currentTarget).addClass('touched');
        });
    }

    bindInputKeyUp() {
        $(this.input).on('keyup', (event) => {

            let item = $(event.currentTarget);

            item.attr('value', $(event.currentTarget).val());

            if (!item.val().trim()) {

                item.addClass('empty');

                if (item.attr('required') === 'required') {
                    item.addClass('required');
                }

            } else {

                item.removeClass('empty');

                if (item.attr('required') === 'required') {
                    item.removeClass('required');
                }
            }
        });
    }

    bindValidate() {

        $(this.input).on('blur keyup', (event) => {

            let item = event.currentTarget;

            if ($(item).attr('type') === 'tel') {
                $(item).val($(item).val().replace(' ', ''));
            }

            this.validate(event.currentTarget);

        });

    }

    validate(item) {

        // check if required

        if ($(item).is('.touched.empty') && $(item).attr('required') === 'required') {

            $(item).addClass('invalid').addClass('invalid-required');
            $(item).removeClass('invalid-email').removeClass('invalid-phone');

        } else if ($(item).attr('required') === 'required' && $(item).val() !== '') {

            $(item).removeClass('invalid').removeClass('invalid-required');

        }

        // check email valid

        if ($(item).is('.touched:not(.empty)') && !this.validateEmail($(item).val()) && $(item).attr('type') === 'email') {

            $(item).addClass('invalid').addClass('invalid-email');

        } else if (this.validateEmail($(item).val()) && $(item).attr('type') === 'email') {

            $(item).removeClass('invalid').removeClass('invalid-email');

        }

        //check numbers

        if ($(item).is('.touched:not(.empty)') && !/^\+?\d+(-\d+)*$/.test($(item).val()) && $(item).attr('type') === 'tel') {

            $(item).addClass('invalid').addClass('invalid-phone');

        } else if (/^\+?\d+(-\d+)*$/.test($(item).val()) && $(item).attr('type') === 'tel') {

            $(item).removeClass('invalid').removeClass('invalid-phone');

        }
    }


    validateEmail(email) {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    bindSubmit() {

        $(this.form).on("submit", (event) => {

            let form = event.currentTarget;
            let valid = true;

            const fields = $(form).find(this.input);

            if (fields.length) {

                fields.each((index, element) => {
                    $(element).addClass('touched');
                    this.validate(element);

                    if ($(element).hasClass('invalid')) {
                        valid = false;
                    }
                });
            }

            $(form).data('valid', valid);

            return valid;

        });

    }

    bindAjaxSubmit() {
        $(document).ready(() => {
            $(this.formsAjax).on("submit", (event) => {
                event.preventDefault();

                const form = $(event.currentTarget);
                const inputs = form.find("input, button");
                const url = form.attr("action");

                if (form.data("valid") && url) {

                    const data = {};

                    inputs.map((index, element) => {
                        const name = $(element).attr("name");
                        const value = $(element).val();

                        $(element).attr("disabled", true);

                        if (name) {
                            data[name] = value;
                        }
                    });

                    form.find(".submit").addClass("button--loading");

                    $.post(url, data)
                        .then((data) => {

                            if (url === "/login" && data === "[logged]") {
                                window.location.reload();
                            } else {
                                form.parent().html(data);
                                this.setEmpty();
                                this.bindFocus();
                                this.bindInputKeyUp();
                                this.bindValidate();
                                this.bindSubmit();
                                this.bindAjaxSubmit();
                            }

                        });

                }
            });
        })
    }

    bindNumber() {
        $(document).ready(() => {
            $(document).on("click", `${this.inputNumber} a.form__number-control--less`, (e) => {
                const input = $(e.currentTarget).parent().find('input');
                const value = input.val();

                if (value > 1) {
                    input.val(parseInt(value) - 1).focus().blur();
                }

                return false;

            });

            $(document).on("click", `${this.inputNumber} a.form__number-control--more`, (e) => {
                const input = $(e.currentTarget).parent().find('input');
                const value = input.val();

                input.val(parseInt(value) + 1).focus().blur();

                return false;

            });
        });
    }

}

export default new Forms();
